// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yodiwo-button-hover:hover {
  background-color: rgba(255, 255, 255, 0.4);
}
.yodiwo-floating-action-button {
  border-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 10px, rgba(0, 0, 0, 0.23) 0px 3px 10px;
  color: #fafafa;
  text-align: center;
  display: inline-block;
  cursor: pointer;
}
.yodiwo-floating-action-button i {
  color: #fafafa;
  font-size: smaller;
}
.yodiwo-floating-action-button i:hover {
  opacity: 0.75;
}
.bg-blue {
  background-color: #0073b7 !important;
}
.bg-yellow {
  background-color: #f39c12 !important;
}
.bg-green {
  background-color: #00a65a !important;
}
.bg-red {
  background-color: #dd4b39 !important;
}
.bg-black {
  background-color: #111111 !important;
}
.primitive-searchbar .rs-input-group {
  border: none;
}
.primitive-searchbar .rs-input-group:not(.rs-input-group-disabled).rs-input-group-focus,
.primitive-searchbar .rs-input-group:focus-within {
  outline: none;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
